var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThresholdIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9 10.8074C9.71744 11.0519 9.3616 11.0772 9.14645 10.8612L6.5541 8.25837L3.9 11.8115C3.73431 12.0333 3.42091 12.0783 3.2 11.9119C2.97909 11.7455 2.93431 11.4309 3.1 11.2091L6.1 7.19287C6.28257 6.94847 6.6384 6.92308 6.85355 7.1391L9.4459 9.74195L12.1 6.18883C12.2657 5.96702 12.5791 5.92206 12.8 6.08842C13.0209 6.25478 13.0657 6.56945 12.9 6.79125L9.9 10.8074Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 0.967773H1.5C0.671573 0.967773 0 1.64207 0 2.47385V15.5265C0 16.3583 0.671573 17.0326 1.5 17.0326H14.5C15.3284 17.0326 16 16.3583 16 15.5265V2.47385C16 1.64207 15.3284 0.967773 14.5 0.967773ZM1 2.47385C1 2.19659 1.22386 1.97182 1.5 1.97182H14.5C14.7761 1.97182 15 2.19659 15 2.47385V15.5265C15 15.8037 14.7761 16.0285 14.5 16.0285H1.5C1.22386 16.0285 1 15.8037 1 15.5265V2.47385Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThresholdIcon);
export default __webpack_public_path__ + "static/media/threshold-icon.a5ff3a2c583bb32e4274c7887efcc1a5.svg";
export { ForwardRef as ReactComponent };